import {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import TabPanel from './TabsPanelComponent'
import {StyledContainer, StyledTabsHeader, StyledTabs, StyledTab} from './TabsComponentStyles'

const Tabs = ({tabsConfig, ariaLabel, initialTabIndex = 0, onTabChange}) => {
  const [value, setValue] = useState(initialTabIndex)

  useEffect(() => {
    setValue(initialTabIndex)
  }, [initialTabIndex])

  const handleTabChange = (_, newValue) => {
    setValue(newValue)
    onTabChange?.(newValue)
  }

  return (
    <StyledContainer>
      <StyledTabsHeader>
        <StyledTabs
          value={value}
          onChange={handleTabChange}
          aria-label={ariaLabel}
          scrollButtons='auto'
          variant='scrollable'
        >
          {tabsConfig.map((tab, index) => (
            <StyledTab
              key={tab.value}
              label={tab.label}
              id={`tab-${index}`}
              aria-controls={`tabpanel-${index}`}
              aria-selected={value === index}
              tabIndex={0}
              disableRipple
              isActive={value === index}
            />
          ))}
        </StyledTabs>
      </StyledTabsHeader>
      {tabsConfig.map((tab, index) => (
        <TabPanel key={tab.value} value={value} index={index} title={tab.title}>
          {tab.component}
        </TabPanel>
      ))}
    </StyledContainer>
  )
}

Tabs.propTypes = {
  tabsConfig: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      component: PropTypes.element.isRequired,
      value: PropTypes.string,
      title: PropTypes.string.isRequired
    })
  ).isRequired,
  ariaLabel: PropTypes.string,
  initialTabIndex: PropTypes.number,
  onTabChange: PropTypes.func
}

export default Tabs
